import React, {useState, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import DaohuuLayoutComponent from '@app/pages/FUtil/DaohuuLayoutComponent';
import {Button, Modal} from "react-bootstrap";
import {myService} from '@app/services/thanhgiaoService';
import {alertService} from '@app/services/alertService';
import {ClipLoader} from "react-spinners";
import {
    image_root, template_upload_root
} from "@app/const/AppSetting";
import './popupimage.css';
import {checkRole} from "@app/services/mainService";
import ProfessionalFileUpload from "@app/components/fileupload/ProfessionalFileUpload";

const TailieuEdit = ({id}) => {
    const [loading, setLoading] = useState(false);
    const [handleToogle, setHandleToogle] = useState(false);
    const [t] = useTranslation();
    const [tailieuList, setTailieuList] = useState([]);
    const initial = {
        isimage: 0
    }
    const [isViewTailieu, setIsViewTailieu] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [obj, setObj] = useState({...initial});
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);

    const [isCreate, setIsCreate] = useState(false);

    const handleFileChange = (e) => {
        // Xử lý khi e là null hoặc không có files
        if (!e || !e.target || !e.target.files || e.target.files.length === 0) {
            setImage(null);
            setPreview(null);
            return;
        }

        const file = e.target.files[0];

        // Kiểm tra file có tồn tại và là File object hợp lệ
        if (!file || !(file instanceof File)) {
            alert("File không hợp lệ, vui lòng chọn lại.");
            setImage(null);
            setPreview(null);
            return;
        }

        // Kiểm tra nếu yêu cầu upload ảnh nhưng file không phải ảnh
        if (obj.isimage && obj.isimage === 1 && !file.type.startsWith("image/")) {
            alert("Vui lòng upload file ảnh.");
            setImage(null);
            setPreview(null);
            return;
        }

        // Kiểm tra kích thước file (ví dụ: tối đa 10MB)
        const maxSize = 100 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
            alert("File quá lớn. Vui lòng chọn file nhỏ hơn 100MB.");
            setImage(null);
            setPreview(null);
            return;
        }

        try {
            setImage(file);

            // Tạo preview URL an toàn
            const previewUrl = URL.createObjectURL(file);
            setPreview(previewUrl);

            // Cleanup URL cũ nếu có
            return () => {
                if (previewUrl) {
                    URL.revokeObjectURL(previewUrl);
                }
            };
        } catch (error) {
            console.error("Lỗi khi tạo preview:", error);
            alert("Không thể tạo preview cho file này.");
            setImage(null);
            setPreview(null);
        }
    };

    // Helper function to check if file is an image
    const isImageFile = (filename) => {
        if (!filename || typeof filename !== 'string') {
            return false;
        }
        return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
    };

    // Helper function to get file extension
    const getFileExtension = (filename) => {
        if (!filename || typeof filename !== 'string') {
            return '';
        }
        return filename.split('.').pop().toLowerCase();
    };

    // Helper function to get file type icon
    const getFileTypeIcon = (filename) => {
        if (!filename || typeof filename !== 'string') {
            return 'fas fa-file text-muted';
        }
        const ext = getFileExtension(filename);
        switch (ext) {
            case 'pdf':
                return 'fas fa-file-pdf text-danger';
            case 'doc':
            case 'docx':
                return 'fas fa-file-word text-primary';
            case 'xls':
            case 'xlsx':
                return 'fas fa-file-excel text-success';
            case 'ppt':
            case 'pptx':
                return 'fas fa-file-powerpoint text-warning';
            case 'txt':
                return 'fas fa-file-alt text-secondary';
            case 'zip':
            case 'rar':
                return 'fas fa-file-archive text-info';
            default:
                return 'fas fa-file text-muted';
        }
    };

    const handleViewFile = (index) => {
        setIsCreate(false);
        setObj(tailieuList[index]);
        setPreview(tailieuList[index].image);
        setShowModal(true);
        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
    };

    const downloadfile = async (rowIndex) => {
        try {
            const result = await myService.downloadFile(tailieuList[rowIndex].id);
            const contentType = result.headers['content-type'];
            const disposition = result.headers['content-disposition'];
            const blob = new Blob([result.data], { type: contentType });

            // Lấy tên file từ header Content-Disposition
            let fileName = "downloaded_file";
            const matches = /filename\*=UTF-8''([^;]+)/.exec(disposition);
            if (matches && matches[1]) {
                fileName = decodeURIComponent(matches[1]);
            }

            // Kiểm tra xem có đúng là blob không
            console.log("File blob size:", blob.size);
            if (blob.size > 0) {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                alertService.success('Download thành công');
            } else {
                alertService.error('Dữ liệu không hợp lệ');
            }
        } catch (error) {
            console.error("Lỗi khi download file:", error);
            alertService.error('Có lỗi xảy ra khi download file');
        }
    };

    const saveClick = async () => {
        let data = obj;
        if (!data) {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }
        if (!image) {
            alert('Vui lòng upload file');
            return;
        }
        create(data, image);
    };

    const loadRef = async (action) => {
        try {
            if (action === 'thanhgiao_tailieu') {
                const tmp = await myService.getRefById(id, action, {});
                setTailieuList(tmp || []); // Đảm bảo luôn có array
                setIsViewTailieu(true);
            } else {
                alert('Chức năng chưa hỗ trợ');
            }
        } catch (error) {
            console.error("Lỗi khi load dữ liệu:", error);
            alert('Có lỗi xảy ra khi tải dữ liệu');
            setTailieuList([]);
        }

        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
    };

    const onChangeInput = (e) => {
        const {name, value, checked} = e.target;

        setObj((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const deletedonhang = async (rowIndex) => {
        try {
            const result = await myService.Delete_Tailieu(tailieuList[rowIndex].id);
            if (result.status === "1") {
                alertService.success(t('fields.label.xoathanhcong'));
                await loadRef('thanhgiao_tailieu');
            } else {
                alertService.error(result.msg);
            }
        } catch (error) {
            console.error("Lỗi khi xóa tài liệu:", error);
            alertService.error('Có lỗi xảy ra khi xóa tài liệu');
        }
    };

    useEffect(() => {
        loadRef('thanhgiao_tailieu');

        // Cleanup function để revoke URLs khi component unmount
        return () => {
            if (preview && preview.startsWith('blob:')) {
                URL.revokeObjectURL(preview);
            }
        };
    }, []);

    async function create(data, fileUpload) {
        setLoading(true);
        try {
            const result = await myService.Create_Tailieu(id, fileUpload, data);

            if (result.status === "1") {
                alertService.success(result.msg);
                await loadRef('thanhgiao_tailieu');
                setShowModal(false);
                setIsViewTailieu(true);

                // Cleanup preview URL
                if (preview && preview.startsWith('blob:')) {
                    URL.revokeObjectURL(preview);
                }
                setPreview(null);
                setImage(null);
            } else {
                alertService.error(result.msg);
            }
        } catch (error) {
            console.error("Lỗi khi tạo tài liệu:", error);
            alertService.error("Có lỗi xảy ra khi upload file");
        }
        setLoading(false);
    }

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50}/>
            </div>
        );
    }

    return <>
        {isViewTailieu ? (<Button
            className="btn btn-secondary  mr-1"
            aria-label="Close"
            onClick={() => {
                setIsViewTailieu(false);
                setTailieuList([]);
                setIsCreate(false);
            }}
        >
            <span aria-hidden="true">Ẩn</span>
        </Button>) : (<Button className="btn btn-info  mr-1" onClick={() => loadRef('thanhgiao_tailieu')}>
                <i className="fa fa-arrow-down"> {"Xem"}</i>
            </Button>
        )
        }
        {
            isViewTailieu && (<Button
                className="btn  btn-success  mr-1"
                icon="right fas fa-angle-left"
                onClick={() => {
                    setShowModal(true);
                    setObj({...initial});
                    setPreview(null);
                    setImage(null);
                    setIsCreate(true);
                }}
            >
                <i className="fa fa-save"> {"Thêm"} </i>
            </Button>)
        }

        <hr/>
        {
            isViewTailieu &&
            (<div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="card-title mb-0">
                                <i className="fas fa-folder-open mr-2"></i>
                                Danh sách tài liệu
                            </h5>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-hover table-striped mb-0">
                                    <thead className="thead-light">
                                    <tr>
                                        <th className="text-center" style={{width: '100px'}}>
                                            Preview
                                        </th>
                                        <th>Tên tài liệu</th>
                                        <th className="text-center" style={{width: '150px'}}>Ghi chú</th>
                                        <th className="text-center" style={{width: '160px'}}>Thao tác</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        tailieuList && tailieuList.length > 0 ? tailieuList.map((item, index) => {
                                            return (
                                                <tr key={index} className="align-middle">
                                                    <td className="text-center p-2">
                                                        {isImageFile(item.filename) ? (
                                                            <div className="thumbnail-container">
                                                                <img
                                                                    src={item.image}
                                                                    alt={item.filename}
                                                                    className="img-thumbnail"
                                                                    style={{
                                                                        width: '80px',
                                                                        height: '80px',
                                                                        objectFit: 'cover',
                                                                        cursor: 'pointer',
                                                                        borderRadius: '8px'
                                                                    }}
                                                                    onClick={() => handleViewFile(index)}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className="file-icon-container d-flex align-items-center justify-content-center"
                                                                style={{
                                                                    width: '80px',
                                                                    height: '80px',
                                                                    backgroundColor: '#f8f9fa',
                                                                    borderRadius: '8px',
                                                                    border: '2px solid #dee2e6',
                                                                    cursor: 'pointer'
                                                                }}
                                                                onClick={() => handleViewFile(index)}>
                                                                <i className={getFileTypeIcon(item.filename)}
                                                                   style={{fontSize: '32px'}}></i>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column">
                                                            <span className="font-weight-medium text-dark">
                                                                {item.filename || 'Tên file không xác định'}
                                                            </span>
                                                            <small className="text-muted">
                                                                {item.filename ? getFileExtension(item.filename).toUpperCase() : 'UNKNOWN'} File
                                                                {item.filetype && ` • ${item.filetype}`}
                                                            </small>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="text-muted small">
                                                            {item.ghichu || '-'}
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="btn-group" role="group">
                                                            <button
                                                                className="btn btn-outline-primary btn-sm"
                                                                title="Xem tài liệu"
                                                                onClick={() => handleViewFile(index)}
                                                            >
                                                                <i className="fas fa-eye"></i>
                                                            </button>
                                                            <button
                                                                className="btn btn-outline-success btn-sm"
                                                                title="Tải xuống"
                                                                onClick={() => downloadfile(index)}
                                                            >
                                                                <i className="fas fa-download"></i>
                                                            </button>
                                                            <button
                                                                className="btn btn-outline-danger btn-sm"
                                                                title="Xóa tài liệu"
                                                                onClick={() => {
                                                                    if (window.confirm(t('fields.label.bancomuonxoa'))) {
                                                                        deletedonhang(index);
                                                                    }
                                                                }}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        }) : (
                                            <tr>
                                                <td colSpan="4" className="text-center text-muted py-4">
                                                    <i className="fas fa-folder-open fa-2x mb-2"></i>
                                                    <div>Chưa có tài liệu nào</div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)
        }

        <Modal size="lg" show={showModal} onHide={() => {
            setShowModal(false)
        }}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fas fa-file-alt mr-2"></i>
                    Tài liệu
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isCreate && (
                    <div className="form-group">
                        <ProfessionalFileUpload
                            obj={obj}
                            onFileChange={handleFileChange}
                            id="fileUpload"
                            name="fileUpload"
                            maxSize={100}
                            className="compact"
                        />
                    </div>
                )}

                <div className="form-group">
                    <label>Ghi chú</label>
                    <input
                        type='text'
                        className="form-control"
                        name="ghichu"
                        id="ghichu"
                        value={obj.ghichu || ''}
                        onChange={(e) => onChangeInput(e)}
                        placeholder="Nhập ghi chú cho tài liệu..."
                    />
                </div>

                <div className='form-group'>
                    {preview && obj.filename && isImageFile(obj.filename) && (
                        <div className="text-center">
                            <img
                                style={{maxHeight: '400px', maxWidth: '100%'}}
                                src={preview}
                                alt="Image Preview"
                                className="img-fluid rounded shadow-sm"
                            />
                        </div>
                    )}
                    {preview && obj.filename && /\.pdf$/i.test(obj.filename) && (
                        <iframe
                            src={preview}
                            style={{width: '100%', height: '500px', border: 'none'}}
                            title="PDF Preview"
                            className="rounded shadow-sm"
                        />
                    )}
                    {preview && obj.filename && !isImageFile(obj.filename) && !/\.pdf$/i.test(obj.filename) && (
                        <div className="text-center p-4 border rounded">
                            <i className={getFileTypeIcon(obj.filename)} style={{fontSize: '48px'}}></i>
                            <div className="mt-3">
                                <a href={preview} target="_blank" rel="noopener noreferrer"
                                   className="btn btn-outline-primary">
                                    <i className="fas fa-download mr-2"></i>
                                    Tải xuống tài liệu
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    setShowModal(false);
                }}>
                    <i className="fas fa-times mr-2"></i>
                    Thoát
                </Button>
                {isCreate && (
                    <Button variant="primary" onClick={saveClick}>
                        <i className="fas fa-check mr-2"></i>
                        Xác nhận
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    </>
};

export default TailieuEdit;